/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "image",
    title: "Image",
    description: "A URI field subtype for image assets. Validates that the value is a valid URI suitable for image sources (URLs or relative paths).",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validUrl: {
            must: true,
            run: function () {
                return validate({ title: "Hero Image" }, "https://example.com/hero.jpg");
            }
        },
        validRelativePath: {
            must: true,
            run: function () {
                return validate({ title: "Logo" }, "../images/logo.png");
            }
        },
        validAbsolutePath: {
            must: true,
            run: function () {
                return validate({ title: "Icon" }, "/assets/icon.svg");
            }
        },
        invalidType: {
            throw: "fields.image.invalid",
            run: function () {
                return validate({ title: "Image" }, 42);
            }
        },
        invalidUri: {
            throw: "fields.image.invalidUri",
            run: function () {
                return validate({ title: "Image" }, "bad image\\path\\thing");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Image",
            description: "The value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        invalidUri: {
            title: "Invalid Image URI",
            description: "The value must be a valid URL or relative path for an image asset.",
            template: "Invalid image URI: '${value}'"
        }
    }
});

// Accepts: http(s) URLs, relative paths (../ ./ /), or @! paths
var imageUriPattern = /^(https?:\/\/|file:\/\/|@!\/|\.{1,2}\/|\/)[\w\-./@!]+$/;

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if (!imageUriPattern.test(value)) {
        _.errors.invalidUri.throw({ value: value });
    }
}
module.exports.validate = validate;
